@let loggedIn = isLoggedIn();
<nav
    aria-label="User"
    class="relative">
    <div
        class="hidden md:block"
        #origin>
        <big-ui-button
            [type]="'button'"
            [buttonStyle]="'none'"
            [classList]="[
                'flex items-center h-8 rounded-full text-white gap-2 pr-3 min-w-[120px] wrap-normal bg-primary-500 dark:bg-primary-400 hover:bg-primary-600 dark:hover:bg-primary-300 outline-offset-2'
            ]"
            [id]="loggedIn ? 'myBigMenuDropDownLoggedIn' : 'myBigMenuDropDownLoggedOut'"
            (clicked)="onUserMenuButtonClick(origin, navUser)">
            <div class="h-7 ml-0.5 flex items-center justify-center aspect-square rounded-full text-[12px] leading-6 bg-primary-400 dark:bg-primary-700">
                <span
                    [class.hidden]="!loggedIn"
                    class="block">
                    {{ userProfile()?.name?.initials }}
                </span>
                <big-icon
                    [icon]="iconLogin"
                    [size]="'w-6'"
                    [class.hidden]="loggedIn"
                    class="fill-current aspect-square" />
            </div>
            @if (loggedIn) {
                <span class="sr-only">{{ loggedInTranslation() }}</span>
            }
            <span>{{ loggedIn ? loggedInText() : loggedOutText() }}</span>
        </big-ui-button>
    </div>
</nav>

<ng-template #navUser>
    <big-nav-user
        (menuItemClicked)="popoverService.closeCurrent()"
        cdkTrapFocus
        [cdkTrapFocusAutoCapture]="true"
        tabindex="0" />
</ng-template>
